import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CreativeUnitPackageListing, PublicCreativeUnitPackageListing } from '../../../../../../../api/src/creative-unit-package-listing/creative-unit-package-listing.entity';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-creative-unit-package-listing-children-dialog',
	templateUrl: './creative-unit-package-listing-children-dialog.component.html',
	styleUrls: ['./creative-unit-package-listing-children-dialog.component.scss']
})
export class CreativeUnitPackageListingChildrenDialogComponent {

	constructor(
		public dialogRef: MatDialogRef<CreativeUnitPackageListingChildrenDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: {
			listing: CreativeUnitPackageListing;
		}
	) {}

	onSelect(listing: PublicCreativeUnitPackageListing) {
		this.dialogRef.close(listing);
	}
}
